type Props = {
  className?: string
}
export const Triangles: React.FC<Props> = ({ className }) => (
  <div className={className}>
    <div className='relative'>
      <svg
        className='absolute bottom-0 left-0 h-24 w-24'
        width='81'
        height='128'
        viewBox='0 0 81 128'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect
          x='16.9429'
          y='-1.6676'
          width='93.2572'
          height='93.2572'
          rx='6'
          transform='rotate(45 16.9429 -1.6676)'
          fill='#FC3C3C'
        />
      </svg>

      <svg
        width='82'
        height='82'
        viewBox='0 0 82 82'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className='absolute bottom-12 left-16 h-12 w-12'
      >
        <rect
          x='41.12'
          y='-1.72571'
          width='60.6172'
          height='60.6172'
          rx='6'
          transform='rotate(45 41.12 -1.72571)'
          fill='#FC3C3C'
        />
      </svg>
      <svg
        width='82'
        height='82'
        viewBox='0 0 82 82'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className='absolute bottom-0 left-16 h-12 w-12'
      >
        <rect
          x='41.12'
          y='-1.72571'
          width='60.6172'
          height='60.6172'
          rx='6'
          transform='rotate(45 41.12 -1.72571)'
          fill='#FC3C3C'
        />
      </svg>
    </div>
  </div>
)
